/* eslint-disable jsx-a11y/label-has-associated-control */
import { type ReactNode, useCallback } from 'react';
import { RadioGroup, Radio } from 'components/inputs/RadioGroup';
import get from 'lodash/get';
import type { TFieldComponentProps } from './types';
import styles from './Toggler.module.scss';

type TTogglerValue = string | number | boolean;

export interface ITogglerOption {
  label: string;
  value: TTogglerValue;
}

export interface ITogglerProps extends TFieldComponentProps<TTogglerValue | null | undefined> {
  options: ITogglerOption[];
  label?: ReactNode;
}

const Toggler = ({ form, options, field, label }: ITogglerProps) => {
  const { errors, touched } = form;
  const { name, value } = field;

  const handleChange = useCallback(
    (v: TTogglerValue) => {
      form.setFieldValue(name, v);
    },
    [name, form],
  );

  return (
    <div className="field-wrapper">
      <label className="label-when-focused-input">{label}</label>
      <RadioGroup
        className={styles.radioGroup}
        name={name}
        selectedValue={value}
        onChange={handleChange}
      >
        {options.map(({ label: optLabel, value: optValue }) => (
          <div key={`${name}.${optLabel}`} className={styles.radioItem}>
            <Radio type="radio" id={`${name}.${optLabel}`} name={name} value={optValue} />
            <label htmlFor={`${name}.${optLabel}`}>{optLabel}</label>
          </div>
        ))}
      </RadioGroup>
      {get(errors, name) && get(touched, name) && (
        <div className="error-text">{get(errors, name)}</div>
      )}
    </div>
  );
};

export default Toggler;
